import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../../../services/security.service';

@Component({
  selector: "com-logout-callback",
  template: ''
})
export class LogoutCallbackComponent implements OnInit {

  constructor(private security: SecurityService, private router: Router) { }

  ngOnInit(): void {
    this.security.completeLogout().then(_ => {
      this.router.navigate(['/'], { replaceUrl: true });
    });
  }

}
